<template>
    <div>
        <h2>Emissão de Nota Fiscal</h2>
        <div class="d-flex w-100 gap-10 search-form">
            <form class="w-100 flex-grow-1 d-flex justify-center align-baseline">
                <v-text-field
                    cols="6"
                    class="pt-5 pb-5"
                    chips
                    clearable
                    hide-details
                    hide-selected
                    prepend-icon="mdi-magnify"
                    label="Pesquisar"
                    solo
                />
            </form>
            
            <v-menu>
                <template v-slot:activator="{ on }">
                    <v-btn
                        color="primary"
                        v-on="on" 
                        large
                        icon
                    >
                        <v-icon>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item
                        v-for="(item, index) in optionTypeNf"
                        :key="index"
                        :value="index"
                        class="cursor-pointer"
                        @click="$router.push({ name: 'CreateIssuance', params: { typeNf: item } })"
                    >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-menu>

            <!-- <div class="text-center">
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="primary"
                            v-on="on" 
                            large
                            icon
                            @click="createValue"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </template>

                </v-menu>
            </div> -->
        </div>
        
        <v-data-table
            :headers="headers"
            :items="itemsData"
            class="elevation-1"
            disable-sort
            hide-default-footer
            :page.sync="page"      
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
        >
            <template  v-slot:[`item.tipoNotaFiscal`]="{ item }">
                <span>
                    {{ item.tipoNotaFiscal?.replaceAll('_', ' ') }}
                </span>
            </template>

            <template v-slot:[`item.statusNf`]="{ item }">
                <v-chip :color="getColorBadge(item.statusNf).color" dark>
                    <span style="font-size: 12px;">
                        {{ item.statusNf == "Denegada" ? "Cancelada" : item.statusNf }} 
                    </span>
                    <v-icon small class="ml-2 text-start">{{ getColorBadge(item.statusNf).icon }}</v-icon>
                </v-chip>
            </template>

            <template v-slot:[`item.notaFiscalDeRemessa`]="{ item }">
                <span>
                    {{ item.notaFiscalDeRemessa ? 'Sim' : 'Não' }}
                </span>
            </template>

            <template v-slot:[`item.chaveAcesso`]="{ item }">
                <span>
                    {{ item.chaveAcesso ||'Não Informado' }}
                </span>
            </template>

            <template v-slot:[`item.numeroNf`]="{ item }">
                <span>
                    {{ JSON.parse(item.plugNotasResponse || '[]')[0]?.numero || 'Não Informado' }}
                </span>
            </template>

            <template  v-slot:[`item.valueNf`]="{ item }">
                <span>
                    {{ formatCurrency(item.valueNf) }}
                </span>
            </template>

            <template  v-slot:[`item.displayValueNf`]="{ item }">
                <span>
                    {{ formatCurrency(item.displayValueNf ?? item.valueNf) }}
                </span>
            </template>

            <template  v-slot:[`item.destinatario`]="{ item }">
                <span>
                    {{ item.notaFiscalDeRemessa ? item.destinatarioFornecedorNome : item.destinatarioNome }}
                </span>
            </template>

            <template v-slot:[`item.createAt`]="{ item }">
                <span>
                    {{  new Date(item.createAt).toLocaleDateString() }}
                </span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">

                <v-menu
                    bottom
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            dark
                            icon
                            v-bind="attrs"
                            v-on="on"
                            color="black"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    
                    <v-list>

                        <v-list-item style="cursor: pointer" @click="editValue(item)">
                            <v-list-item-title>
                                <span>
                                    Editar
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="item.statusNf === 'Pendente'"
                            style="cursor: pointer" @click="deletePendingInvoice(item)">
                            <v-list-item-title>
                                <span>
                                    Deletar Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item 
                           
                            style="cursor: pointer" @click="previeNf(item)">
                            <v-list-item-title>
                                <span>
                                    Pré-Visualização
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item 
                            v-if="item.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço' && item.statusNf !== 'Emitida'"
                            style="cursor: pointer" @click="emitirNotaFiscal(item)">
                            <v-list-item-title>
                                <span>
                                    Emitir Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço' && item.statusNf !== 'Emitida'"
                        style="cursor: pointer" @click="emitirNotaFiscalServico(item)">
                            <v-list-item-title>
                                <span>
                                    Emitir Nota Fiscal de serviço
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.statusNf === 'Emitida'"
                        style="cursor: pointer" @click="handleAlertCancel(item)">
                            <v-list-item-title>
                                <span>
                                   Cancelar Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item

                        style="cursor: pointer" @click="item.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço' ? resumoNotaFiscal(item) : resumoNotaFiscalServico(item)">
                            <v-list-item-title>
                                <span>
                                    Consultar Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.statusNf === 'Emitida'"
                        style="cursor: pointer" @click="geratedPdf(item)">
                            <v-list-item-title>
                                <span>
                                    Gerar PDF da Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item
                        v-if="item.statusNf === 'Emitida'"
                        style="cursor: pointer" @click="geratedXml(item)">
                            <v-list-item-title>
                                <span>
                                    Gerar XML da Nota Fiscal
                                </span>
                            </v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        
        <div class="text-center pt-2">
            <v-pagination
                v-model="page"
                :length="pageCount"
                @input="pagination"
            ></v-pagination>
        </div>-


        <!-- <CreateIssuanceInvoiceView 
            :item="itemNf"
            :open="openCreateIssuance"
            @cancel="openCreateIssuance = false"
            @save="handleSave"
        /> -->

        <previe-nota-fiscal-view 
            :open="openPreview"
            :notasFiscalPreVisualizacao="previewNf"
            @back="openPreview = false"
        />

        <alert-cancel-view
            :isOpen="openAlertCancel"
            @cancel="openAlertCancel = false"
            @confirmar="confirmCancel"
        />

        <preview-nota-fiscal-servico-view 
            :open="openPreviewNfServico"
            :notaInfo="previewNf"
            @close="openPreviewNfServico = false"
        />

        <v-dialog
            v-model="errorValidationDialog"
            max-width="800"
        >
            <v-card>
                <v-card-title class="headline">
                    {{ errorValidationTitle }}
                </v-card-title>
                <v-card-text>
                    <div v-if="errorValidationMessages && errorValidationMessages.length">
                        <ul>
                            <li
                                v-for="(msg, index) in errorValidationMessages"
                                :key="index"
                            >
                                {{ msg }}
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        Ocorreu uma falha na validação da prévia da DANFe.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="errorValidationDialog = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="rejectionReasonDialog"
            max-width="700"
        >
            <v-card>
                <v-card-title class="headline error white--text">
                    {{ rejectionReasonTitle }}
                </v-card-title>
                <v-card-text class="error--text pt-6">
                    {{ rejectionReasonMessage || 'A nota fiscal foi rejeitada, mas a API nao retornou um motivo.' }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="error" text @click="rejectionReasonDialog = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
//import CreateIssuanceInvoiceView from './CreateIssuanceInvoiceView.vue';
import Vue from 'vue';
import axios from 'axios';
import PrevieNotaFiscalView from './PrevieNotaFiscalView.vue';
import AlertCancelView from './AlertCancelView.vue';
import moment from 'moment';
import PreviewNotaFiscalServicoView from './PreviewNotaFiscalServicoView.vue';
import EntityService from '../../services/entityService';

export default {
    name: 'IssuanceInvoiceView',
    components: {
        PrevieNotaFiscalView,
        AlertCancelView,
        PreviewNotaFiscalServicoView
        //CreateIssuanceInvoiceView
    },
    data(){
        return {
            emissaoDocEntity: new EntityService('EmissaoNotasFiscais'),
            fisPreDocEmiEntity: new EntityService('FisPreDocEmi'),
            fisDocServiceEntity: new EntityService('FisDocService'),
            optionTypeNf: [
                'Nota Fiscal', 
                'Nota Fiscal de Remessa',
                'Nota Fiscal de Serviço'
            ],
            isCfopsNfMae: ['6922'],
            previewNf: null,
            openAlertCancel: false,
            openPreviewNfServico: false,
            openPreview: false,
            openCreateIssuance: false,
            itemsData: [],
            headers: [
                { text: 'Tipo de Nota Fiscal', value: 'tipoNotaFiscal' },
                { text: 'Nota de Remessa', value: 'notaFiscalDeRemessa' },
                { text: 'Status', value: 'statusNf' },
                { text: 'Chave de Acesso', value: 'chaveAcesso' },
                { text: 'Número da NF', value: 'numeroNf' },
                { text: 'Valor sem Impostos', value: 'valueNf' },
                { text: 'Valor com Impostos', value: 'displayValueNf' },
                { text: 'Destinatario', value: 'destinatario' },
                { text: 'Data de Criação', value: 'createAt' },
                { text: 'Actions', value: 'actions'}
            ],
            page: 1,
            pageCount: 0,
            itemsPerPage: 0,
            itemNf: null,
            authorizate: null,
            baseUrl: process.env.VUE_APP_PLUGNOTAS_API_URL || 'https://api.sandbox.plugnotas.com.br',
            apiKey: process.env.VUE_APP_PLUGNOTAS_API_X_API_KEY || '2da392a6-79d2-4304-a8b7-959572c7e44d',
            errorValidationDialog: false,
            errorValidationTitle: 'Falha na validação da prévia da DANFe',
            errorValidationMessages: [],
            rejectionReasonDialog: false,
            rejectionReasonTitle: 'Nota fiscal rejeitada',
            rejectionReasonMessage: ''
        }
    },
    methods: {
        formatCurrency(value) {
            return Number(value || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        },

        toMonetaryValue(value) {
            const numericValue = Number(value || 0)

            if (!Number.isFinite(numericValue)) return 0

            return numericValue / 100
        },

        async getInvoiceDisplayValue(item) {
            if (item?.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço') {
                return Number(item.valueNf || 0)
            }

            const notaFiscal = item?.notaFiscal?.[0]
            const itemIds = notaFiscal?.itens || []

            if (!Array.isArray(itemIds) || itemIds.length === 0) {
                return Number(item.valueNf || 0)
            }

            const response = await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                params: {
                    ids: itemIds.join(','),
                    sortField: 'sequencia'
                }
            })

            const nfItems = response?.data?.data?.data || []

            const totals = nfItems.reduce((accumulator, nfItem) => {
                accumulator.ipi += this.toMonetaryValue(nfItem.ipiValor)
                accumulator.frete += this.toMonetaryValue(nfItem.valorFrete)
                accumulator.seguro += this.toMonetaryValue(nfItem.valorSeguro)
                accumulator.desconto += this.toMonetaryValue(nfItem.valorDesconto)
                accumulator.outros += this.toMonetaryValue(nfItem.valorOutros)
                return accumulator
            }, {
                ipi: 0,
                frete: 0,
                seguro: 0,
                desconto: 0,
                outros: 0
            })

            return Number(item.valueNf || 0)
                + totals.ipi
                + totals.frete
                + totals.seguro
                - totals.desconto
                + totals.outros
        },

        async enrichInvoiceDisplayValues(items) {
            return Promise.all(
                (items || []).map(async (item) => ({
                    ...item,
                    displayValueNf: await this.getInvoiceDisplayValue(item)
                }))
            )
        },

        getColorBadge(status) {
            switch (status) {
                case 'Emitida':
                return { color: 'primary', icon: 'mdi-check-circle' };

                case 'Processando':
                return { color: 'warning', icon: 'mdi-loading' };

                case 'Rejeitado':
                return { color: 'error', icon: 'mdi-alert-circle' };

                case 'Denegada':
                return { color: 'error', icon: 'mdi-close-circle' };

                default:
                return { color: 'grey', icon: 'mdi-help-circle' };
            }
        },

        getResumoInvoiceStatus(status) {
            switch (status) {
                case 'CONCLUIDO':
                    return 'Emitida'
                case 'REJEITADO':
                    return 'Rejeitado'
                case 'CANCELADO':
                    return 'Denegada'
                default:
                    return 'Processando'
            }
        },

        openRejectionReasonModal(message) {
            this.rejectionReasonTitle = 'Nota fiscal rejeitada'
            this.rejectionReasonMessage = message || 'A nota fiscal foi rejeitada, mas a API nao retornou um motivo.'
            this.rejectionReasonDialog = true
        },

        getChaveAcesso(response) {
            const data = JSON.parse(response)
            if(data?.length > 0 && data[0]?.chave){
                return data[0]?.chave
            } else if(data?.message){
                return data?.message
            } else {
                return 'Não Informado'
            }
        },

        async getIssuanceInvoices(){
            const response = await Vue.prototype.$http.post(`/View/run`,
                {
                    "params": [],
                    "viewId": "2a39c593-02d0-46d4-be8c-6dc43dc18c9a",
                    "page": this.page,
                    "limit": 30
                }
            );

            this.itemsData = await this.enrichInvoiceDisplayValues(response.data.data.data)
            this.pageCount = response.data.data.pages
            this.itemsPerPage = response.data.data.limit
        },
        pagination(page) {
            this.page = page
            this.getIssuanceInvoices()
        },
        async handleSave(){
            this.openCreateIssuance = false
            await this.getIssuanceInvoices()
        },

        createValue(){
            this.itemNf = null
            this.openCreateIssuance = true
        },

        getEntityRecordId(record) {
            if (!record) return null

            if (Array.isArray(record)) {
                return this.getEntityRecordId(record[0])
            }

            return record._id || record.id || record
        },

        getEntityRecord(record) {
            if (!record) return null

            if (Array.isArray(record)) {
                return record[0] || null
            }

            return typeof record === 'object' ? record : null
        },

        async deleteEntityItems(schemaName, ids = []) {
            const validIds = (ids || []).filter(Boolean)

            if (!validIds.length) return

            await Promise.all(
                validIds.map((id) => Vue.prototype.$http.delete(`/Entity/${schemaName}?id=${id}`))
            )
        },

        async deletePendingInvoice(item) {
            if (item.statusNf !== 'Pendente') return

            const isServiceInvoice = item.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço'
            const confirmar = await this.$confirm(
                isServiceInvoice
                    ? 'Tem certeza que deseja deletar esta nota fiscal de serviço pendente?'
                    : 'Tem certeza que deseja deletar esta nota fiscal pendente?'
            )

            if (!confirmar) return

            try {
                this.$notfy.warning('Excluindo nota fiscal pendente...')

                const notaFiscal = this.getEntityRecord(item.notaFiscal)
                const notaFiscalServico = this.getEntityRecord(item.notaFiscalServico)

                if (notaFiscal) {
                    await Promise.all([
                        this.deleteEntityItems('FisPreDocEmiItem', notaFiscal.itens),
                        this.deleteEntityItems('FisPreDocEmiFin', notaFiscal.parcelas)
                    ])

                    await this.fisPreDocEmiEntity.delete(this.getEntityRecordId(notaFiscal))
                }

                if (notaFiscalServico) {
                    await this.deleteEntityItems('FisPreDocEmiFin', notaFiscalServico.parcelas)
                    await this.fisDocServiceEntity.delete(this.getEntityRecordId(notaFiscalServico))
                }

                await this.emissaoDocEntity.delete(this.getEntityRecordId(item))

                this.$notfy.success('Nota fiscal pendente deletada com sucesso.')
                await this.getIssuanceInvoices()
            } catch (error) {
                this.$notfy.error('Erro ao deletar nota fiscal.', error.response?.data || error.message)
                console.error('Erro ao deletar nota fiscal:', error.response?.data || error.message)
            }
        },
        
        editValue(value){
            this.$router.push({
                name: 'CreateIssuance',
                params: { typeNf: value.tipoNotaFiscal.replaceAll('_', ' ') },
                query: {
                    id: value._id
                }
            })
        },

        async geratedPdf(itemNf){
            let file
            let fileName = itemNf.tipoNotaFiscal === 'Nota_Fiscal_de_Serviço' ? 'nota-fiscal-serviço.pdf' : 'nota-fiscal.pdf'

            if(itemNf.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço'){
                let plugResponse = JSON.parse(itemNf.plugNotasResponse)[0]
                file = await axios.get(plugResponse.pdf,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            } else {
                let plugResponse = JSON.parse(itemNf.plugNotasResponse)
                file = await axios.get(`${this.baseUrl}/nfse/pdf/${plugResponse.id}`,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            }

            const url = window.URL.createObjectURL(new Blob([file.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

        },
        
        async geratedXml(itemNf){
            let file

            if(itemNf.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço'){
                let plugResponse = JSON.parse(itemNf.plugNotasResponse)[0]
                file = await axios.get(plugResponse.xml,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            } else {

                let plugResponse = JSON.parse(itemNf.plugNotasResponse)
                file = await axios.get(`${this.baseUrl}/nfse/xml/${plugResponse.id}`,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                )
            }
            
            const url = window.URL.createObjectURL(new Blob([file.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'nota-fiscal.xml');
            document.body.appendChild(link);
            link.click();
            link.remove();

        },

        async resumoNotaFiscalServico(nfInfo){
            this.$notfy.warning(`Gerando o resumo da nota fiscal.`)
            
            let plugResponse = JSON.parse(nfInfo.plugNotasResponse)
            console.log('plugResponse >>> ', plugResponse)
            let id = plugResponse.documents[0]?.id

            /*
                                'https://api.plugnotas.com.br/nfse',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': '21c94f51-ca20-4ba0-a6d2-ffc23291680c',
                            'Content-Type': 'application/json'
                        }
                    }
            */

            const response = await axios.get(`${this.baseUrl}/nfse/${id}`, {
                headers: {
                    'X-API-KEY': this.apiKey,
                    'Content-Type': 'application/json'
                },
            });


            const objEmissao = {
                plugNotasID: nfInfo.plugNotasID,
                plugNotasMensagem: response.data.retorno.mensagemRetorno,
                plugNotaIdIntegracao: nfInfo.plugNotaIdIntegracao,
                tipoNotaFiscal: nfInfo.tipoNotaFiscal.replaceAll('_', ' '),
                destinatario: nfInfo.destinatario,
                destinatarioFornecedor: undefined,
                statusNf: response.data.status == "CONCLUIDO" ? "Emitida" : "",
                notaFiscalServico: nfInfo.notaFiscalServico[0]._id,
                valueNf: Number(nfInfo.valueNf),
                id: nfInfo._id,
                plugNotasResponse: JSON.stringify(response.data),
                chaveAcesso: response.data.retorno.codigoVerificacao,
                notaFiscalDeRemessa: nfInfo.notaFiscalDeRemessa
            }

            await Promise.all([
                Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                Vue.prototype.$http.put('/Entity/FisDocService', {
                    ...nfInfo.notaFiscalServico[0],
                    id: nfInfo.notaFiscalServico[0]._id,
                    _id: undefined,
                    jobItensList: undefined,
                    status: response.data.status == "CONCLUIDO" ? "Concluído" : "",
                    emitenteTipoEnquadramento: nfInfo.notaFiscalServico[0].emitenteTipoEnquadramento || '',
                    tomadorIm: nfInfo.notaFiscalServico[0].tomadorIm || '',
                    fornecedor: nfInfo.notaFiscalServico[0].fornecedor || '',
                    cnpj: nfInfo.notaFiscalServico[0].emitenteCpfOrCnpj || '',
                    numero: response.data.retorno.numeroNfse || '',
                    pedido: nfInfo.notaFiscalServico[0].pedido || '',
                    pdf: nfInfo.notaFiscalServico[0].pdf || undefined,
                    reasoning: nfInfo.notaFiscalServico[0].reasoning || '',
                    codigoCidade: nfInfo.notaFiscalServico[0].codigoCidade || '',
                    jobItens: nfInfo.notaFiscalServico[0].jobItens,
                    tributacao: undefined,
                    cnae: nfInfo.notaFiscalServico[0].cnae || undefined,
                    cnaeCodigo: nfInfo.notaFiscalServico[0].cnaeCodigo || undefined,
                    cnaeDescricao: nfInfo.notaFiscalServico[0].cnaeDescricao || undefined,
                    tributacaoMunicipal: nfInfo.notaFiscalServico[0].tributacaoMunicipal || undefined,
                    regimeTributario: nfInfo.notaFiscalServico[0].regimeTributario || undefined,
                    regimeTributarioCodigo: nfInfo.notaFiscalServico[0].regimeTributarioCodigo || undefined,
                    regimeTributarioDescricao: nfInfo.notaFiscalServico[0].regimeTributarioDescricao || undefined,
                    enquadramentoServico: nfInfo.notaFiscalServico[0].enquadramentoServico || undefined,
                    enquadramentoServicoCodigo: nfInfo.notaFiscalServico[0].enquadramentoServicoCodigo || undefined,
                    enquadramentoServicoDescricao: nfInfo.notaFiscalServico[0].enquadramentoServicoDescricao || undefined,
                    emitenteCnae: nfInfo.notaFiscalServico[0].emitenteCnae || undefined,
                    emitenteCodCidade: nfInfo.notaFiscalServico[0].emitenteCodCidade || undefined
                })
            ])

            if(response.data.status == "CONCLUIDO"){

                const responseParcelas = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: nfInfo.notaFiscalServico[0]?.parcelas.map((item) => item ).join(',')
                    }
                })

                const parcelas = responseParcelas?.data?.data?.data

                let fisDocEmiFinIds = []
                let fisDocRecFinS = []
                let finRecCad = []

                let objItensFinRec = []

                if (parcelas?.length > 0) {
                    parcelas.forEach((p, index) => {
                        objItensFinRec.push({
                            status: "Prevista",
                            origem: "Nota Fiscal Emitida",
                            parcela: index + 1,
                            notaFiscalServico: nfInfo.notaFiscalServico[0]._id,
                            job: nfInfo.notaFiscalServico[0]?.job,
                            cliente: nfInfo.destinatario,
                            valorOriginal: p.vlr / 100,
                            valorRecebido: 0,
                            valorSaldo: p.vlr / 100,
                            dataCriacao:  moment().format("YYYY-MM-DD"),
                            dataVencimento: p.dtPag
                                ? moment(new Date(p.dtPag)).format("YYYY-MM-DD")
                                : moment(new Date(nfInfo.notaFiscalServico[0]?.dataSaida)).format("YYYY-MM-DD"),
                            descricao: "Gerado pela pré-nota " + nfInfo.notaFiscalServico[0]?.codigo,
                            observacao: "",
                        });
                    });

                    const responseInsertFinRec = await Vue.prototype.$http.post("/Entity/insertMany/FinRec", objItensFinRec)
                    finRecCad = responseInsertFinRec.data.data

                } else {

                    await Vue.prototype.$http.post("/Entity/FinRec", {
                        origem: "Nota Fiscal Emitida",
                        status: "Prevista",
                        parcela: nfInfo.notaFiscalServico[0].parcelas?.length || 1,
                        preNota: nfInfo.notaFiscalServico[0]._id,
                        job: nfInfo.notaFiscalServico[0].job,
                        cliente: nfInfo.destinatario,
                        valorOriginal: Number(nfInfo.valueNf),
                        dataCriacao:  moment().format("YYYY-MM-DD"),
                        dataVencimento: moment(nfInfo.notaFiscalServico[0]?.dataSaida).format('YYYY-MM-DD'),
                        descricao: "Gerado pela pré-nota " + nfInfo.notaFiscalServico[0]?.codigo,
                        observacao: "",
                        // notaFiscalEmitida: responseFisDocEmi.data.data.id
                    })
                }

                fisDocRecFinS = responseParcelas?.data?.data?.data?.map((item, index) => {

                    delete item.createAt
                    delete item.updateAt
                    delete item.createBy
                    delete item.updateBy
                    delete item.deleteAt
                    delete item.deleteBy
                    delete item.isDeleted
                    delete item.id

                    return {
                        ...item,
                        vlr: item.vlr / 100,
                        contaAReceber: finRecCad[index]?.id
                    }
                })

                //FisDocEmiFin
                const responseFisPreDocEmiItem = await Vue.prototype.$http.post('/Entity/insertMany/FisDocEmiFin', fisDocRecFinS)

                fisDocEmiFinIds = responseFisPreDocEmiItem?.data?.data?.map((item) => {
                    return item.id
                })

                const responseFisDocEmi = await Vue.prototype.$http.post('/Entity/FisDocEmi', {
                    job: nfInfo.notaFiscalServico[0]?.job,
                    preNota: nfInfo.notaFiscalServico[0]?._id,
                    // Mudar Aqui
                    filial: nfInfo.notaFiscalServico[0]?.filial || "c511a33d-6b85-4cdf-88af-6a221f0eb46d",
                    //serie: response.data[0].serie,
                    numero: response.data.retorno.numeroNfse,
                    chaveAcesso: response.data.retorno.codigoVerificacao,
                    tipo: nfInfo?.tipoNotaFiscal == 'Nota_Fiscal' ? 'Venda' : this.optionTypeNf == 'Nota_Fiscal_de_Remessa' ? 'Remessa' : 'Serviço',
                    destino: this.optionTypeNf != 'Nota Fiscal de Remessa' ? 'Cliente' : 'Fornecedor',
                    dataEmissao: moment(nfInfo.notaFiscalServico[0]?.dataEmissao || nfInfo.notaFiscalServico[0]?.createAt).format('YYYY-MM-DD'),
                    dataSaida: moment(nfInfo.notaFiscalServico[0].dataSaida).format('YYYY-MM-DD'),
                    cliente: nfInfo?.destinatario || undefined,
                    fornecedor: nfInfo?.destinatarioFornecedor || undefined,
                    cfop: undefined,
                    notaFiscalValor: Number(nfInfo.valueNf),
                    valorFinanceiro: Number(nfInfo.valueNf),
                    parcelas: fisDocEmiFinIds,
                    plugNotasId: id,
                    statusEmissao: "EMITIDA",
                    transportadora: undefined,
                    descontoValor: 0,
                    freteValor: 0,
                    outroValor: 0,
                    produtoValor: nfInfo.notaFiscalServico[0].valorUnitario,
                    ipiValor: nfInfo.notaFiscalServico[0].ipi,
                    icmsValor: nfInfo.notaFiscalServico[0].icms,
                    pisValor: nfInfo.notaFiscalServico[0].pis,
                    cofinsValor: nfInfo.notaFiscalServico[0].confins,
                    tipoFrete: undefined
                })

                finRecCad.map((item) => {
                    delete item.createBy
                    item.notaFiscalEmitida = responseFisDocEmi.data.data.id
                    return item
                })

                if(finRecCad.length > 0) await Vue.prototype.$http.put('/entity/updateMany/FinRec', finRecCad)

            }

            this.$notfy.success(`Nota Fiscal Atualizada com status ${response.data.status}.`)
            await this.getIssuanceInvoices()
        },

        async resumoNotaFiscal(nfInfo){
            console.log('nfInfo >>> ', JSON.parse(nfInfo?.plugNotasResponse))
            this.$notfy.warning(`Gerando o resumo da nota fiscal.`)
            let plugResponse = JSON.parse(nfInfo?.plugNotasResponse)
            let idIntegracao = plugResponse?.documents?.[0] ? plugResponse?.documents[0]?.idIntegracao : plugResponse[0]?.idIntegracao

            let ipiTotal = 0
            let totalPis = 0;
            let totalCofins = 0;
            let totalIcms = 0;
            let totalValorFrete = 0
            let totalValorSeguro = 0
            let totalValorOutros = 0
            let totalValorDeconto = 0


            let url = '';
            //let emitente = plugResponse.documents[0]?.Emitente;
            url = `${this.baseUrl}/nfe/02823203000103/${idIntegracao}/resumo`;

            const response = await axios.get(url, {
                headers: {
                    'X-API-KEY': this.apiKey,
                    'Content-Type': 'application/json',
                },
            });

            console.log('resumo >>> ', response, nfInfo)
            
            const objEmissao = {
                plugNotasID: nfInfo.plugNotasID,
                plugNotasMensagem: response.data[0].mensagem,
                plugNotaIdIntegracao: response.data[0].plugNotaIdIntegracao,
                tipoNotaFiscal: nfInfo.tipoNotaFiscal?.replaceAll('_', ' '),
                destinatario: nfInfo.destinatario || undefined,
                destinatarioFornecedor: nfInfo.destinatarioFornecedor || undefined,
                statusNf: this.getResumoInvoiceStatus(response.data[0].status),
                notaFiscal: nfInfo.notaFiscal[0]._id,
                valueNf: Number(nfInfo.valueNf),
                id: nfInfo._id,
                plugNotasResponse: JSON.stringify(response.data),
                chaveAcesso: response.data[0].chave,
                notaFiscalDeRemessa: nfInfo.notaFiscalDeRemessa
            }

            Promise.all([
                Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                Vue.prototype.$http.put('/Entity/FisPreDocEmi', {
                        id: nfInfo.notaFiscal[0]._id,
                        codigo: nfInfo.notaFiscal[0].codigo,
                        addRetirada: nfInfo.notaFiscal[0].addRetirada,
                    statusEmissao: response.data[0].status == 'REJEITADO' ? 'Rejeitado' : nfInfo.notaFiscal[0].statusEmissao,
                        plugNotasID: nfInfo.plugNotasID,
                        plugNotasMensagem: response.data[0].mensagem,
                        filial: nfInfo.notaFiscal[0].filial,
                        job: nfInfo.notaFiscal[0]?.job || undefined,
                        romaneio: nfInfo.notaFiscal[0]?.romaneio || undefined,
                        cliente: nfInfo.destinatario || undefined,
                        fornecedor: nfInfo?.destinatarioFornecedor || undefined,
                        cnpj: nfInfo.notaFiscal[0].cnpj,
                        dataEmissao: nfInfo.notaFiscal[0].dataEmissao,
                        naturezaOperacao: nfInfo.notaFiscal[0].naturezaOperacao,
                        defFiscais: nfInfo.notaFiscal[0].defFiscais || undefined,
                        condicaoPagamento: nfInfo.notaFiscal[0].condicaoPagamento,
                        destinatarioCep: nfInfo.notaFiscal[0].destinatarioCep,
                        destinatarioCidade: nfInfo.notaFiscal[0].destinatarioCidade,
                        destinatarioLogradouro: nfInfo.notaFiscal[0].destinatarioLogradouro,
                        destinatarioNumero: nfInfo.notaFiscal[0].destinatarioNumero,
                        destinatarioBairro: nfInfo.notaFiscal[0].destinatarioBairro,
                        codigoCidade: nfInfo.notaFiscal[0].codigoCidade,
                        uf: nfInfo.notaFiscal[0].uf,
                        email: nfInfo.notaFiscal[0].email,
                        notaFiscalMae: nfInfo.notaFiscal[0].notaFiscalMae || undefined,
                        itens: nfInfo.notaFiscal[0].itens || [],
                        parcelas: nfInfo.notaFiscal[0].parcelas || [],
                        dataSaida: nfInfo.notaFiscal[0].dataSaida,
                        valorBaseDeCalculo:  nfInfo.notaFiscal[0].valorBaseDeCalculo,
                        transportadora: nfInfo.notaFiscal[0]?.transportadora,
                        volumeQuantidade: nfInfo.notaFiscal[0].volumeQuantidade,
                        especie: nfInfo.notaFiscal[0].especie,
                        marca: nfInfo.notaFiscal[0].marca,
                        volumeNumeracao: nfInfo.notaFiscal[0].numeracao,
                        pesoBruto: nfInfo.notaFiscal[0].pesoBruto,
                        pesoLiquido: nfInfo.notaFiscal[0].pesoLiquido,
                        valorFrete: nfInfo.notaFiscal[0].valorFrete,
                        valorSeguro: nfInfo.notaFiscal[0].valorSeguro,
                        valorDesconto: nfInfo.notaFiscal[0].valorDesconto,
                        valorOutros: nfInfo.notaFiscal[0].valorOutros,
                        ncm: nfInfo.notaFiscal[0].ncm,
                        cest: nfInfo.notaFiscal[0].cest || undefined,
                        cfop: nfInfo.notaFiscal[0].cfop || undefined,
                        fisOper: nfInfo.notaFiscal[0].operacaoFiscal,
                        codigoBeneficioFiscal: nfInfo.notaFiscal[0]?.codigoBeneficioFiscal || undefined,
                        meioPagamento: nfInfo.notaFiscal[0].meioPagamento.replaceAll('_', ' ') || undefined,
                        informacaoAdd: nfInfo.notaFiscal[0]?.informacaoAdd,
                })
            ])

            if (response.data[0].status == 'REJEITADO') {
                this.openRejectionReasonModal(response.data[0].mensagem)
            }

            if(response.data[0].status == "CONCLUIDO"){

                // Itens FisDocRecItem
                const responseItens = await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                    params: {
                        ids: nfInfo.notaFiscal[0].itens.map((item) => item ).join(',')
                    }
                })

                let fisDocEmiItens = responseItens.data.data.data.map((fisEmiItem, index) => {

                    delete fisEmiItem.createAt
                    delete fisEmiItem.updateAt
                    delete fisEmiItem.createBy
                    delete fisEmiItem.updateBy
                    delete fisEmiItem.deleteAt
                    delete fisEmiItem.deleteBy
                    delete fisEmiItem.isDeleted

                    ipiTotal += fisEmiItem.ipiValor / 100
                    totalPis += fisEmiItem.pisValor / 100
                    totalCofins += fisEmiItem.cofinsValor / 100
                    totalIcms += fisEmiItem.icmsValor / 100

                    totalValorFrete += Number(fisEmiItem.valorFrete / 100)
                    totalValorSeguro += Number(fisEmiItem.valorSeguro / 100)
                    totalValorOutros += Number(fisEmiItem.valorOutros / 100)
                    totalValorSeguro += Number(fisEmiItem.valorSeguro / 100)


                    return {
                        ...fisEmiItem,
                        sequencia: index + 1,
                        ipiBaseCalculo: fisEmiItem.ipiBaseCalculo / 100,
                        valorUnitario: fisEmiItem.valorUnitario / 100,
                        valorTotal: fisEmiItem.valorTotal / 100,
                        pisValor: fisEmiItem.pisValor / 100,
                        ipiPercentual: fisEmiItem.ipiPercentual,
                        ipiValor: fisEmiItem.ipiValor / 100,
                        pisBaseCalculo: fisEmiItem.pisBaseCalculo / 100,
                        cofinsBaseCalculo: fisEmiItem.cofinsBaseCalculo / 100,
                        resultBaseCalcICMS: fisEmiItem.resultBaseCalcICMS / 100,
                        icmsPercentual: String(fisEmiItem.icmsPercentual),
                        icmsBaseCalculo: fisEmiItem.icmsBaseCalculo / 100,
                        icmsValor: fisEmiItem.icmsValor / 100,
                        cofinsValor: fisEmiItem.cofinsValor / 100,
                        itemDescription: undefined,
                        id: undefined,
                        ctsIpi: undefined
                    }

                })

                const responseFisPreDocEmiItem = await Vue.prototype.$http.post('/Entity/insertMany/FisDocEmiItem', fisDocEmiItens)

                let fisDocEmiIds = responseFisPreDocEmiItem?.data?.data?.map((item) => {
                    return item.id
                })

                // Fim



                let fisDocEmiFinIds = []
                let fisDocRecFinS = []
                let finRecCad = []

                if(nfInfo.notaFiscal[0].parcelas?.length  > 0 && nfInfo.tipoNotaFiscal == 'Nota_Fiscal'){

                    const responseParcelas = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                        params: {
                            ids: nfInfo.notaFiscal[0].parcelas.map((item) => item ).join(',')
                        }
                    })

                    const parcelas = responseParcelas?.data?.data?.data

                    let objItensFinRec = []
                    if (!nfInfo.notaFiscalDeRemessa || !this.isCfopsNfMae.includes(nfInfo.notaFiscal[0].cfop)) {
                        if (parcelas?.length > 0) {
                            parcelas.forEach((p, index) => {
                                objItensFinRec.push({
                                    status: "Prevista",
                                    origem: "Nota Fiscal Emitida",
                                    parcela: index + 1,
                                    preNota: nfInfo.notaFiscal[0]._id,
                                    job: nfInfo.notaFiscal[0].job,
                                    cliente: nfInfo.destinatario,
                                    valorOriginal: p.vlr / 100,
                                    valorRecebido: 0,
                                    valorSaldo: p.vlr / 100,
                                    dataCriacao:  moment().format("YYYY-MM-DD"),
                                    dataVencimento: p.dtPag
                                        ? moment(new Date(p.dtPag)).format("YYYY-MM-DD")
                                        : moment(new Date(nfInfo.notaFiscal[0].dataSaida)).format("YYYY-MM-DD"),
                                    descricao: "Gerado pela pré-nota " + nfInfo.notaFiscal[0].codigo,
                                    observacao: "",
                                });
                            });

                            const responseInsertFinRec = await Vue.prototype.$http.post("/Entity/insertMany/FinRec", objItensFinRec)
                            finRecCad = responseInsertFinRec.data.data

                        } else {

                            await Vue.prototype.$http.post("/Entity/FinRec", {
                                origem: "Nota Fiscal Emitida",
                                status: "Prevista",
                                parcela: nfInfo.notaFiscal[0].parcelas?.length || 1,
                                preNota: nfInfo.notaFiscal[0]._id,
                                job: nfInfo.notaFiscal[0].job,
                                cliente: nfInfo.destinatario,
                                valorOriginal: Number(nfInfo.valueNf),
                                dataVencimento: moment(nfInfo.notaFiscal[0].dataSaida).format('YYYY-MM-DD'),
                                dataCriacao:  moment().format("YYYY-MM-DD"),
                                //notaFiscalEmitida: responseFisPreDocEmi.data.data.id,
                                descricao: "Gerado pela pré-nota " + nfInfo.notaFiscal[0].codigo,
                                observacao: "",
                               // notaFiscalEmitida: responseFisDocEmi.data.data.id
                            })
                        }
                    }

                    fisDocRecFinS = responseParcelas?.data?.data?.data?.map((item, index) => {

                        delete item.createAt
                        delete item.updateAt
                        delete item.createBy
                        delete item.updateBy
                        delete item.deleteAt
                        delete item.deleteBy
                        delete item.isDeleted
                        delete item.id

                        return {
                            ...item,
                            vlr: item.vlr / 100,
                            contaAReceber: finRecCad[index]?.id
                        }
                    })

                    //FisDocEmiFin
                    const responseFisPreDocEmiItem = await Vue.prototype.$http.post('/Entity/insertMany/FisDocEmiFin', fisDocRecFinS)

                    fisDocEmiFinIds = responseFisPreDocEmiItem?.data?.data?.map((item) => {
                        return item.id
                    })

                }

                const tipoFrete = nfInfo.notaFiscal[0]?.project[0]?.freteTipo;

                const resultTipoFrete = tipoFrete
                    ?.replaceAll('_', ' ')
                    ?.replace(/\s+/g, ' ')
                    ?.trim();

                //console.log('resultTipoFrete ', resultTipoFrete, nfInfo.notaFiscal[0]?.project[0].freteTipo)

                const responseFisDocEmi = await Vue.prototype.$http.post('/Entity/FisDocEmi', {
                    job: nfInfo.notaFiscal[0].job,
                    preNota: nfInfo.notaFiscal[0]._id,
                    filial: nfInfo.notaFiscal[0].filial,
                    serie: response.data[0].serie,
                    numero: response.data[0].numero,
                    chaveAcesso: response.data[0].chave,
                    tipo: nfInfo?.tipoNotaFiscal == 'Nota_Fiscal' ? 'Venda' : this.optionTypeNf == 'Nota_Fiscal_de_Remessa' ? 'Remessa' : 'Serviço',
                    destino: this.optionTypeNf != 'Nota Fiscal de Remessa' ? 'Cliente' : 'Fornecedor',
                    dataEmissao: moment(nfInfo.notaFiscal[0]?.dataEmissao || nfInfo.notaFiscal[0]?.createAt).format('YYYY-MM-DD'),
                    dataSaida: moment(nfInfo.notaFiscal[0].dataSaida).format('YYYY-MM-DD'),
                    cliente: nfInfo?.destinatario || undefined,
                    fornecedor: nfInfo?.destinatarioFornecedor || undefined,
                    cfop:  "",
                    notaFiscalValor: Number(nfInfo.valueNf) // subtotal dos produtos (vProd)
                        - (totalValorDeconto || 0) // desconto
                        + (totalValorFrete  || 0)    // frete
                        + (totalValorOutros  || 0)   // outras despesas
                        + (totalValorSeguro  || 0)  // seguro
                        + ipiTotal,                                     // IPI entra
                        // + totalIcmsST,
                    valorFinanceiro: Number(nfInfo.valueNf),
                    itens: fisDocEmiIds,
                    parcelas: fisDocEmiFinIds,
                    plugNotasId: response.data[0].id,
                    statusEmissao: "EMITIDA",
                    transportadora: nfInfo.notaFiscal[0]?.transportadora || nfInfo.notaFiscal[0]?.project?.transportadora || undefined,
                    descontoValor: totalValorDeconto || 0,
                    freteValor: totalValorFrete,
                    outroValor: totalValorOutros,
                    produtoValor: Number(nfInfo.valueNf),
                    seguroValor: totalValorSeguro || undefined,
                    informacoesAdicionais: nfInfo.notaFiscal[0]?.project[0]?.informacoesAdicionais || undefined,
                    //freteTipo: nfInfo.notaFiscal[0].project[0]?.freteTipo.replaceAll("_", ' ') || undefined,
                    volumeQuantidade: nfInfo.notaFiscal[0]?.volumeQuantidade || undefined,
                    volumeTipo: nfInfo.notaFiscal[0].project[0]?.volumeTipo || undefined,
                    pesoBruto: nfInfo.notaFiscal[0]?.pesoBruto || undefined,
                    pesoLiquido: nfInfo.notaFiscal[0]?.pesoLiquido || undefined,
                    //Impostos
                    valorBaseDeCalculo: nfInfo.notaFiscal[0].valorBaseDeCalculo,
                    ipiValor: ipiTotal,
                    icmsValor: totalIcms,
                    pisValor: totalPis,
                    cofinsValor: totalCofins,
                    tipoFrete: nfInfo.notaFiscal[0]?.tipoFrete || resultTipoFrete|| undefined,
                    meioPagamento: nfInfo.notaFiscal[0]?.meioPagamento.replaceAll('_', ' ') || undefined
                })

                //console.log('responseFisPreDocEmi >>> ', nfInfo.notaFiscal[0].project[0].tranportadora[0]?._id, responseFisPreDoc

                if(nfInfo.tipoNotaFiscal == 'Nota_Fiscal'){
                    finRecCad.map((item) => {
                        delete item.createBy
                        item.notaFiscalEmitida = responseFisDocEmi.data.data.id
                        return item
                    })

                   if(finRecCad.length > 0) await Vue.prototype.$http.put('/entity/updateMany/FinRec', finRecCad)
                }

            }

            this.$notfy.success(`Nota Fiscal Atualizada com status ${response.data[0].status}.`)
            await this.getIssuanceInvoices()

        },

        async previeNf(nfInfo) {

            if(nfInfo.tipoNotaFiscal == 'Nota_Fiscal_de_Serviço'){
                this.openPreviewNfServico = true
                this.previewNf = nfInfo
                return
            }

            const payload = await this.emitirPreviewNotaFiscal(nfInfo, false)

            console.log('nfInfo ', payload)

            //const payload = JSON.parse(nfInfo.plugNotasResponse)[0] || JSON.parse(nfInfo.plugNotasResponse)


            this.$notfy.warning(`Gerando a pré-visualização da nota fiscal.`)

            await new Promise(r => setTimeout(r, 5000));


            const response = await axios.get(`https://api.plugnotas.com.br/nfe/${payload?.protocol || ""}/preview`,{
                responseType: 'arraybuffer',
                responseEncoding: 'binary',
                ContentType: 'application/pdf', 
                headers:{
                    "Content-Type": 'application/json',
                    "x-api-key": "5bbf2aa2efee08a50be2cefaf8ab8811"
                },
                
            })
            
            const buffer = Buffer.from(response.data);
            const base64Pdf = buffer.toString('base64');

            this.previewNf = base64Pdf;
            this.openPreview = true;

        },
        
        async emitirPreviewNotaFiscal(nfInfo) {

            this.$notfy.warning("Gerando...")

            const nfData = await this.createObjectEmissao(nfInfo)

            console.log('api key: ', this.apiKey)

            try {
                const response = await axios.post(
                    'https://api.plugnotas.com.br/nfe/preview',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': "5bbf2aa2efee08a50be2cefaf8ab8811",
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('NF enviada com sucesso!');
                //this.$notfy.success("Nota Fiscal Gerada com sucesso.")

                return response.data;

            } catch (error) {
                const apiError = error?.response?.data;

                console.log('apiError >>> ', apiError)

                if (apiError && apiError.error && apiError.error.message === 'Falha na validação do JSON de Prévia da DANFe') {
                    const fields = apiError.error.data && apiError.error.data.fields ? apiError.error.data.fields : {};

                    const detailList = Object.keys(fields).length
                        ? Object.entries(fields).map(([field, msg]) => `${field}: ${msg}`)
                        : [];

                    this.errorValidationTitle = 'Falha na validação da prévia da DANFe';
                    this.errorValidationMessages = detailList;
                    this.errorValidationDialog = true;
                } else {
                    this.$notfy.error('Erro ao emitir NF: ' + (apiError?.message || error.message));
                }

                console.error('Erro ao emitir NF:', error.response?.data || error.message);
            }

        },

        async emitirNotaFiscal(nfInfo) {

            if(this.errorValidationDialog) return

            this.$notfy.warning("Gerando...")

            const nfData = await this.createObjectEmissao(nfInfo)

            try {
                const response = await axios.post(
                    'https://api.plugnotas.com.br/nfe',
                    [ nfData ],
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('NF enviada com sucesso!');
                this.$notfy.success("Nota Fiscal Gerada com sucesso.")
                
                const idIntegracao = response.data.documents[0]?.idIntegracao
                const idPlugNota = response.data.documents[0]?.id
                const menssage = response.data?.message

                const objEmissao = {
                    plugNotasID: idPlugNota,
                    plugNotasMensagem: menssage,
                    plugNotaIdIntegracao: idIntegracao,
                    tipoNotaFiscal: nfInfo.tipoNotaFiscal?.replaceAll('_', ' '),
                    destinatario: nfInfo.destinatario || undefined,
                    destinatarioFornecedor: nfInfo.destinatarioFornecedor || undefined,
                    statusNf: "Processando",
                    notaFiscal: nfInfo.notaFiscal[0]._id,
                    valueNf: Number(nfInfo.valueNf),
                    id: nfInfo._id,
                    plugNotasResponse: JSON.stringify(response.data),
                    notaFiscalDeRemessa: nfInfo.notaFiscalDeRemessa
                }

                const responseItens = await Vue.prototype.$http('/Entity/FisPreDocEmiItem/search-fields',  {
                    params: {
                        ids: nfInfo.notaFiscal[0].itens.map((id) => id).join(',')
                    }
                })

                const itens = responseItens.data.data.data
                console.log('responseItens >>>> ', itens)

                let sumBaseCalculo = 0
                let sumIpi = 0
                let sumCofins = 0
                let sumPis = 0
                let sumIcms = 0

                itens.map((item) => {
                    sumBaseCalculo += (Number(item.ipiBaseCalculo) / 100 + Number(item.icmsBaseCalculo) / 100 + Number(item.pisBaseCalculo) / 100 + Number(item.cofinsBaseCalculo) / 100)
                    sumIpi += Number(item.ipiValor) / 100
                    sumCofins += Number(item.cofinsValor) / 100
                    sumPis += Number(item.pisValor) / 100
                    sumIcms += Number(item.icmsValor) / 100
                })

                console.log('sumBaseCalculo >>> ', sumBaseCalculo)

                await Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisPreDocEmi', {
                        id: nfInfo.notaFiscal[0]._id,
                        codigo: nfInfo.notaFiscal[0].codigo,
                        addRetirada: nfInfo.notaFiscal[0].addRetirada,
                        statusEmissao: "PROCESSANDO",
                        plugNotasID: idPlugNota,
                        plugNotasMensagem: menssage,
                        filial: nfInfo.notaFiscal[0].filial,
                        job: nfInfo.notaFiscal[0]?.job || undefined,
                        romaneio: nfInfo.notaFiscal[0]?.romaneio || undefined,
                        cliente: nfInfo.destinatario || undefined,
                        fornecedor: nfInfo.destinatarioFornecedor || undefined,
                        cnpj: nfInfo.notaFiscal[0].cnpj,
                        dataEmissao: nfInfo.notaFiscal[0].dataEmissao,
                        naturezaOperacao: nfInfo.notaFiscal[0].naturezaOperacao,
                        defFiscais: nfInfo.notaFiscal[0].defFiscais || undefined,
                        condicaoPagamento: nfInfo.notaFiscal[0].condicaoPagamento,
                        destinatarioCep: nfInfo.notaFiscal[0].destinatarioCep,
                        destinatarioCidade: nfInfo.notaFiscal[0].destinatarioCidade,
                        destinatarioLogradouro: nfInfo.notaFiscal[0].destinatarioLogradouro,
                        destinatarioNumero: nfInfo.notaFiscal[0].destinatarioNumero,
                        destinatarioBairro: nfInfo.notaFiscal[0].destinatarioBairro,
                        codigoCidade: nfInfo.notaFiscal[0].codigoCidade,
                        uf: nfInfo.notaFiscal[0].uf,
                        email: nfInfo.notaFiscal[0].email,
                        notaFiscalMae: nfInfo.notaFiscal[0].notaFiscalMae || undefined,
                        itens: nfInfo.notaFiscal[0].itens || [],
                        parcelas: nfInfo.notaFiscal[0].parcelas || [],
                        dataSaida: nfInfo.notaFiscal[0].dataSaida,
                        //
                        seguroValor: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.seguroValor || undefined,
                        informacaoAdd: nfInfo.notaFiscal[0]?.informacaoAdd,
                        informacoesAdicionais: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.informacoesAdicionais || undefined,
                        //freteTipo: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.replaceAll("_", ' ') || undefined,
                        //volumeQuantidade: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.volumeQuantidade || undefined,
                        volumeTipo: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.volumeTipo || undefined,
                        //pesoBruto: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.pesoBruto || undefined,
                        //pesoLiquido: nfInfo.notaFiscal[0]?.project[0]?.tranportadora[0]?.pesoLiquido || undefined,
                        valorBaseDeCalculo: sumBaseCalculo,
                        ipiValor: sumIpi,
                        icmsValor: sumIcms,
                        pisValor: sumPis,
                        cofinsValor: sumCofins,
                        transportadora: nfInfo.notaFiscal[0]?.transportadora,
                        volumeQuantidade: Number(nfInfo.notaFiscal[0].volumeQuantidade),
                        especie: nfInfo.notaFiscal[0].especie,
                        marca: nfInfo.notaFiscal[0].marca,
                        volumeNumeracao: nfInfo.notaFiscal[0].numeracao,
                        pesoBruto: nfInfo.notaFiscal[0].pesoBruto,
                        pesoLiquido: nfInfo.notaFiscal[0].pesoLiquido,
                        valorFrete: nfInfo.notaFiscal[0].valorFrete,
                        valorSeguro: nfInfo.notaFiscal[0].valorSeguro,
                        valorDesconto: nfInfo.notaFiscal[0].valorDesconto,
                        valorOutros: nfInfo.notaFiscal[0].valorOutros,
                        ncm: nfInfo.notaFiscal[0].ncm,
                        cest: nfInfo.notaFiscal[0].cest || undefined,
                        cfop: nfInfo.notaFiscal[0].cfop || undefined,
                        fisOper: nfInfo.notaFiscal[0].operacaoFiscal,
                        codigoBeneficioFiscal: nfInfo.notaFiscal[0]?.codigoBeneficioFiscal || undefined,
                        meioPagamento: nfInfo.notaFiscal[0].meioPagamento.replaceAll('_', ' ') || undefined,
                    })
                ])

                await this.getIssuanceInvoices()

            } catch (error) {
                this.$notfy.error("Erro ao emitir NF: ", error.response?.data || error.message)
                console.error('Erro ao emitir NF:', error.response?.data || error.message);
            }
        },

        async emitirNotaFiscalServico(infoNf){
            this.$notfy.warning("Gerando...")
            console.log('emitirNotaFiscalServico ', infoNf)
            // baseUrl: 'https://api.sandbox.plugnotas.com.br', // 'https://api.plugnotas.com.br',
            // apiKey: '2da392a6-79d2-4304-a8b7-959572c7e44d', // '21c94f51-ca20-4ba0-a6d2-ffc23291680c',

            let parcelasIds = infoNf.notaFiscalServico[0].parcelas || []
            let parcelas = []

            if(parcelasIds.length > 0){
                const responseParcelas = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: parcelasIds.map((item) => item ).join(','),
                    }
                })

                responseParcelas.data.data.data.map((item, index) => {
                    parcelas.push({
                        "numero": (index + 1).toString().padStart(3, '0'),
                        "tipoPagamento": 5,
                        "dataVencimento": item.dtPag,
                        "valorParcela": Number((item.vlr / 100).toFixed(2))
                    })
                })
            }
            
            let servico = infoNf.notaFiscalServico[0]?.jobItensList.map((item) => {
                return {
                    "codigo": infoNf.notaFiscalServico[0].enquadramentoServicoCodigo?.replace(/\D/g, ''),
                    "codigoTributacao": infoNf.notaFiscalServico[0].enquadramentoServicoCodigo,
                    "discriminacao": item?.descricao,
                    "cnae": infoNf.notaFiscalServico[0]?.cnaeCodigo?.replace(/\D/g, ''),
                    "iss": {
                        "tipoTributacao": 7,
                        "exigibilidade": 1,
                        "aliquota": 2
                    },
                    "valor": {
                        "liquido": infoNf.notaFiscalServico[0].vlrLiquido / 100,
                        "baseCalculo": infoNf.notaFiscalServico[0].baseCalculo || infoNf.valueNf,
                        "servico": item.precoTotal || infoNf.valueNf,
                        "descontoCondicionado": 0,
                        "descontoIncondicionado": 0
                    },
                    "retencao": {
                        "pis": {
                            "valor": infoNf.notaFiscalServico[0].vlrPIS / 100 || undefined
                        },
                        "cofins": {
                            "valor": infoNf.notaFiscalServico[0].vlrCOFINS / 100 || undefined
                        },
                        "csll": {
                            "valor": infoNf.notaFiscalServico[0].vlrSCLL / 100 || undefined
                        },
                        "inss": {
                            "valor": infoNf.notaFiscalServico[0].vrlINSS / 100 || undefined
                        },
                        "irrf": {
                            "valor": infoNf.notaFiscalServico[0].vlrIR / 100 || undefined
                        }
                    }
                }
            })

            const nfData = [
                {
                    "lote": 2,
                    "idIntegracao": `${Math.floor(10000000 + Math.random() * 90000000)}`,
                    "naturezaOperacao": 1,
                    "optanteSimplesNacional": false,
                    "incentivadorCultural": false,
                    "regimeEspecialTributacao": 0,
                    "status": 1,
                    "rps": {
                        "dataEmissao": new Date(),
                        "envioSincrono": true
                    },
                    "prestador": {
                        "cpfCnpj": infoNf.notaFiscalServico[0].emitenteCpfOrCnpj?.replace(/\D/g, ''),
                        "inscricaoMunicipal": infoNf.notaFiscalServico[0].emitenteIm,
                        "nomeFantasia": infoNf.notaFiscalServico[0].emitenteRazaoSocial,
                        "endereco": {
                            "codigoCidade": infoNf.notaFiscalServico[0].emitenteCodCidade || '3539103',
                            "estado": "SP",
                            "bairro": infoNf.notaFiscalServico[0].emitenteBairro,
                            "descricaoCidade": infoNf.notaFiscalServico[0].emitenteLocalEmissao,
                            "logradouro": infoNf.notaFiscalServico[0].emitenteLogradouro,
                            "numero": "",
                            "cep": "06550000"
                        }
                    },
                    "tomador": {
                        "cpfCnpj": infoNf.notaFiscalServico[0].tomadorCpfOrCnpj?.replace(/\D/g, ''),
                        "razaoSocial": infoNf.notaFiscalServico[0].tomadorCpfOrCnpj.tomadorRazaoSocial,
                        "inscricaoMunicipal": infoNf.notaFiscalServico[0]?.tomadorIm || undefined,
                        "email": infoNf.notaFiscalServico[0]?.tomadorEmail,
                        "endereco": {
                            "codigoCidade": infoNf.notaFiscalServico[0]?.codigoCidade?.replace(/\D/g, ''),
                            "descricaoCidade": infoNf.notaFiscalServico[0].tomadorEndereco.split('-')[0].split('Cidade:')[1].trim(''),
                            "logradouro": infoNf.notaFiscalServico[0].tomadorEndereco.split('-')[1].split('Rua:')[1].trim(''),
                            "estado": infoNf.notaFiscalServico[0].tomadorUf,
                            "utilizarDadosTomador": false,
                            "numero": infoNf.notaFiscalServico[0].tomadorNumero, //"21",
                            "bairro": infoNf.notaFiscalServico[0].tomadorEndereco.split('-')[2].split('Bairro:')[1].trim(''),
                            "cep": infoNf.notaFiscalServico[0].tomadorCep?.replace(/\D/g, ''),
                        }
                    },
                    "parcelas": parcelas,
                    "servico": servico
                }
            ]



            try {
                const response = await axios.post(
                    'https://api.plugnotas.com.br/nfse',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('response >>> ', response.data.documents[0])

                const idIntegracao = response.data.documents[0]?.idIntegracao
                const idPlugNota = response.data.documents[0]?.id
                const menssage = response?.message

                const objEmissao = {
                    plugNotasID: idPlugNota,
                    plugNotasMensagem: menssage,
                    plugNotaIdIntegracao: idIntegracao,
                    tipoNotaFiscal: infoNf.tipoNotaFiscal.replaceAll('_', ' '),
                    destinatario: infoNf.destinatario,
                    statusNf: "Processando",
                    notaFiscalServico: infoNf.notaFiscalServico[0]._id,
                    valueNf: Number(infoNf.valueNf),
                    id: infoNf._id,
                    plugNotasResponse: JSON.stringify(response.data),
                    chaveAcesso: response.data.documents[0]?.chave
                }

                await Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisDocService', {
                        ...infoNf.notaFiscalServico[0],
                        id: infoNf.notaFiscalServico[0]._id,
                        _id: undefined,
                        jobItensList: undefined,
                        status: "Processando",
                        emitenteTipoEnquadramento: infoNf.notaFiscalServico[0].emitenteTipoEnquadramento || '',
                        tomadorIm: infoNf.notaFiscalServico[0].tomadorIm || '',
                        fornecedor: infoNf.notaFiscalServico[0].fornecedor || '',
                        cnpj: infoNf.notaFiscalServico[0].emitenteCpfOrCnpj || '',
                        numero: infoNf.notaFiscalServico[0].numero || '',
                        pedido: infoNf.notaFiscalServico[0].pedido || '',
                        pdf: infoNf.notaFiscalServico[0].pdf || undefined,
                        reasoning: infoNf.notaFiscalServico[0].reasoning || '',
                        codigoCidade: infoNf.notaFiscalServico[0].codigoCidade || '',
                        jobItens: infoNf.notaFiscalServico[0].jobItens,
                        tributacao: undefined,
                        cnae: infoNf.notaFiscalServico[0].cnae || undefined,
                        cnaeCodigo: infoNf.notaFiscalServico[0]?.cnaeCodigo || undefined,
                        cnaeDescricao: infoNf.notaFiscalServico[0].cnaeDescricao || undefined,
                        tributacaoMunicipal: infoNf.notaFiscalServico[0].tributacaoMunicipal || undefined,
                        regimeTributario: infoNf.notaFiscalServico[0].regimeTributario || undefined,
                        regimeTributarioCodigo: infoNf.notaFiscalServico[0].regimeTributarioCodigo || undefined,
                        regimeTributarioDescricao: infoNf.notaFiscalServico[0].regimeTributarioDescricao || undefined,
                        enquadramentoServico: infoNf.notaFiscalServico[0].enquadramentoServico || undefined,
                        enquadramentoServicoCodigo: infoNf.notaFiscalServico[0].enquadramentoServicoCodigo || undefined,
                        enquadramentoServicoDescricao: infoNf.notaFiscalServico[0].enquadramentoServicoDescricao || undefined,
                        emitenteCnae: infoNf.notaFiscalServico[0].emitenteCnae || undefined,
                        emitenteCodCidade: infoNf.notaFiscalServico[0].emitenteCodCidade || undefined
                    })
                ])

                console.log('NF enviada com sucesso!', response.data);
                this.$notfy.success("Nota Fiscal de Serviço Gerada com sucesso.")

                await this.getIssuanceInvoices()

            } catch (error) {
                this.$notfy.error("Erro ao emitir NF: ", error.response?.data || error.message)
                console.error('Erro ao emitir NF:', error.response?.data || error.message);
            }
        },
        
        sanitizeDescricao(text) {
            return text
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\r?\n|\r/g, " ")
                .replace(/[^A-Za-z0-9\s\-.,/]/g, "");
        },

        getCodigoTributario(value, fallback = "") {
            if (value === null || value === undefined) return fallback;

            const texto = String(value).trim();
            if (!texto.length) return fallback;

            const codigo = texto.split(" - ")[0].trim();
            return codigo || fallback;
        },

        async createObjectEmissao(nfInfo) {

            console.log('nfInfo ', nfInfo)


            let romaneiosNfInfo = nfInfo.notaFiscal[0]?.romaneio
            let parcelas = nfInfo.notaFiscal[0]?.parcelas
            let fisPreDocEmiItem = nfInfo.notaFiscal[0]?.itens
            let itens = []
            let sum = 0

            let fisPreDocEmiFin = [];
            let parcelasFormatadas = [];
            let valorLiquido = 0;
            let totalCobranca = 0;

            if (parcelas?.length > 0 && !nfInfo.notaFiscalDeRemessa) {
                const parcelasResponse = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: parcelas.map((id) => id).join(','),
                        sortField: 'parcelaSequencia'
                    }
                })

                fisPreDocEmiFin = parcelasResponse.data.data.data

                // Cria array de parcelas formatadas e soma valores
                parcelasFormatadas = fisPreDocEmiFin.reduce((acc, p) => {
                    acc.push({
                        dataVencimento: new Date(p.dtPag),
                        numero: `00${p.parcelaSequencia}`,
                        tipoPagamento: 1,
                        valor: p.vlr / 100
                    });
                    valorLiquido += p.vlr / 100;
                    totalCobranca += p.vlr / 100;
                    return acc;
                }, []);
            }

            let romaneios = []
            if(romaneiosNfInfo?.length > 0){
                const romaneioResponse = await Vue.prototype.$http.get('/Entity/Romaneio/search-fields', {
                    params: {
                        ids: romaneiosNfInfo.map((id) => id).join(','),
                    }
                })

                romaneios = romaneioResponse.data.data.data
            }

            let localRetirada = {}
            let isRetiradaAndEntrega = nfInfo.notaFiscal[0]?.addRetirada == true
            if(isRetiradaAndEntrega){

                const response = await Vue.prototype.$http.post('/Action/run', 
                    { 
                        actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                        actionName: "Action info CNPJ",
                        params: { 
                            cnpj: nfInfo.notaFiscal[0]?.cnpjFilial?.replace(/\D/g, '') || "02823203000103"
                        } 
                    })
                    
                const infoResponse = response.data.data.data
                console.log('infoResponse >>> ', infoResponse)

                
                const match = infoResponse.telefone.match(/\((\d{2})\)\s*(\d{4,5}-\d{4})/);

                if (match) {
                    var ddd = match[1];     // "11"
                    var numero = match[2];  // "3218-6666"
                    
                    console.log("DDD:", ddd);
                    console.log("Número:", numero);
                }

                localRetirada = {
                    cpfCnpj: nfInfo.notaFiscal[0]?.cnpjFilial?.replace(/\D/g, ''),
                    razaoSocial: infoResponse.nome,
                    telefone: {
                        numero: numero?.replace(/\D/g, ''),
                        ddd: ddd
                    },
                    email: infoResponse.email,
                    endereco: {
                        descricaoCidade: infoResponse.municipio,
                        bairro: infoResponse.bairro,
                        cep: infoResponse.cep.replace(/\D/g, ''),
                        codigoCidade: "3550308",
                        numero: infoResponse.numero,
                        estado: infoResponse.uf,
                        logradouro: infoResponse.logradouro,
                        tipoLogradouro: "Rua"
                    }
                }
            }

            let transportadora
            if(nfInfo.notaFiscal[0]?.transportadora){
                const response = await Vue.prototype.$http.get(`/Entity/Fornecedor/${nfInfo.notaFiscal[0]?.transportadora}`)
                transportadora = response.data.data
            }

            if(fisPreDocEmiItem?.length > 0){
                await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
                    params: {
                        ids: fisPreDocEmiItem.map(id => id).join(','),
                        sortField: 'sequencia'
                    }
                }).then((response) => {

                    response.data.data.data.map((item) => {
                        sum += item.valorTotal

                        const valorIbs = Number(
                            ((item.valorTotal / 100) * (this.ibs / 100)).toFixed(3)
                        )

                        const valorCbs = Number(
                            ((item.valorTotal / 100) * (this.cbs / 100)).toFixed(3)
                        )

                        const cstIcms = this.getCodigoTributario(item.ctsIcms, "00");
                        const origemIcms = this.getCodigoTributario(item.icmsOrigem || item.origemMercadoria || item.origem, "0");

                        // Corta até o limite
                        let descricaoCortada = item?.descricao.substring(0, 120)

                        // Evita cortar palavra no meio
                        const ultimoEspaco = descricaoCortada.lastIndexOf(" ")

                        if (ultimoEspaco > 0) {
                            descricaoCortada = descricaoCortada.substring(0, ultimoEspaco)
                        }

                        const complemento = item?.descricao.substring(descricaoCortada.length).trim()
                        
                        itens.push({
                            "codigo": item.codigo,
                            "descricao": this.removerAcentos(descricaoCortada),
                            "ncm": nfInfo.notaFiscal[0]?.ncm?.replace(/\D/g, '') || "00",
                            "cest": nfInfo.notaFiscal[0].cest?.replace(/\D/g, '') || "0123456",
                            "cfop": nfInfo.notaFiscal[0]?.cfop || "5101",
                            "valorFrete": item?.valorFrete / 100,
                            "valorDesconto": item?.valorDesconto / 100,
                            "valorOutros": item?.valorOutros / 100,
                            "valorSeguro": item?.valorSeguro / 100,
                            "informacoesComplementares": `${complemento} Itens conforme o romaneio ${romaneios.map((rm) => rm.codigo).join(' ')} Pedido de Compra: ${nfInfo.notaFiscal[0]?.project[0]?.pedidoCompra || ''}-${item?.observacao || ''}` || undefined,
                            //"pedidoCompra": item?.pedidodecompra || 0,
                            //"numeroCompra": item?.sequenciaPedidoDeCompra || 0,
                            "unidade": {
                                "comercial": item?.unidadeSigla || "PC",
                                "tributavel": item?.unidadeSigla || "PC"
                            },
                            "valorUnitario": {
                                "comercial": item.valorUnitario / 100,
                                "tributavel": item.valorUnitario / 100
                            },
                            "quantidade": {
                                "comercial": Number(item.quantidade.replaceAll(',', '.')),
                                "tributavel": Number(item.quantidade.replaceAll(',', '.'))
                            },
                            "valor": item.valorTotal / 100,
                            "codigoBeneficioFiscal": nfInfo.notaFiscal[0]?.codigoBeneficioFiscal || undefined,
                            "tributos": {
                                "ibscbs": { // classificacaoIbsCbs
                                    "cst": item.cstIbsCbsCodigo,
                                    "classificacao": item.classificacaoIbsCbsCodigo,
                                    //"valorIbs": item.valorBaseCalculoIbsCbs / 100,
                                    "baseCalculo": item.valorBaseCalculoIbsCbs / 100,
                                    /*
                                    "municipio": {
                                        "aliquota": 0,
                                        "valor": 0
                                    },
                                    /*"uf": {
                                        "aliquota": item.aliquotaUf ? Number(item.aliquotaUf.replaceAll(',', '.')) : 0,
                                        "valor": item.valorUf ? item.valorUf / 100 : 0
                                    },
                                    "cbs": {
                                        "aliquota": 0, //Number(String(item.percentualBaseCalculoIbsCbs || 0).replaceAll(',', '.')) || 0,
                                        "valor": item.valorCbs ? item.valorCbs / 100 : 0
                                    },*/
                                },
                                "icms": {
                                    "origem": origemIcms,
                                    "cst": cstIcms,
                                    "baseCalculo": nfInfo?.tipoNotaFiscal === "Nota_Fiscal" ?  {
                                        "modalidadeDeterminacao": 0,
                                        "valor": item.resultBaseCalcICMS / 100 || item.icmsBaseCalculo / 100 || undefined,
                                        "percentualReducao": item.icmsPercentualBaseCalculo > 0 ? Number(item.icmsPercentualBaseCalculo.replaceAll(',', '.')) : undefined
                                    } : {
                                        valor: 0,
                                        modalidadeDeterminacao: 0
                                    },
                                    "aliquota": Number(String(item.icmsPercentual || 0).replaceAll(',', '.')) || 0,
                                    "valor": item.icmsValor ? item.icmsValor / 100 : 0,
                                    "substituicaoTributaria": cstIcms == "10" || cstIcms == "70" ? {
                                        "aliquota": Number(item.aliqDestinoICMS?.replaceAll(',', '.')) || undefined,
                                        "baseCalculo": {
                                            "modalidadeDeterminacao": Number(item.modalidadeDeterminacao?.split(' - ')[0]) || 0,
                                            "valor": item.resultBaseCalcICMS / 100 || undefined
                                        }
                                    } : undefined
                                },
                                "pis": {
                                    "cst": item?.ctsPis?.split(" - ")[0] || "01",
                                    "baseCalculo": {
                                        "valor": item.pisBaseCalculo / 100,
                                        "quantidade": 0
                                    },
                                    "aliquota": Number(item.pisPercentual.replaceAll(',', '.')) || 0,
                                    "valor": Number(item.pisValor) / 100,
                                    //"aliquotaReais": 0,
                                    //"quantidadeVendida": 0
                                },
                                "cofins": {
                                    "cst": item?.ctsCofins?.split(" - ")[0] || "01",
                                    "baseCalculo": {
                                        "valor": item.cofinsBaseCalculo / 100
                                    },
                                    "aliquota": Number(item?.cofinsPercentual?.replaceAll(',', '.')) || 0,
                                    "valor": item.cofinsValor / 100
                                },
                                "ipi": {
                                    "cst": item?.ctsIpi?.split(" - ")[0] || "50",
                                    "baseCalculo": item.ipiBaseCalculo / 100,
                                    "valor": item.ipiValor / 100,
                                    "aliquota": Number(item?.ipiPercentual),
                                    "codigoEnquadramentoLegal": "103"
                                }
                            }
                        })
                    })
                })

                //console.log('fisPreDocEmiItem >>> ', itens)
            }

            const destinatarioInfoBase = nfInfo.notaFiscalDeRemessa
                ? nfInfo?.destinatarioInfoFornecedor?.[0]
                : nfInfo?.destinatarioInfo?.[0]

            const telefoneDestinatario = destinatarioInfoBase?.contatos?.[0]?.telefone?.replace(/\D/g, '')

            const nfData =
                {
                    idIntegracao: `XXXYY${Math.floor(100000 + Math.random() * 900000)}`,
                    //transmitir: true,
                    presencial: "1",
                    consumidorFinal: true,
                    informacoesComplementares: 'NOSSO JOB ' + nfInfo.notaFiscal[0].project[0].code +  nfInfo?.notaFiscal[0]?.informacaoAdd?.replace(/\n/g, "") || '',
                    natureza: nfInfo.notaFiscal[0]?.naturezaOperacao || "OPERAÇÃO INTERNA",
                    notaReferenciada: nfInfo.notaFiscal[0]?.notaFiscalMae ? {
                        nfe: [ 
                            { chave: nfInfo.notaFiscal[0]?.notaFiscalMae }
                        ]
                    } : undefined,
                    emitente: {
                        cpfCnpj: nfInfo.notaFiscal[0]?.cnpjFilial?.replace(/\D/g, '') || "02823203000103",
                        inscricaoEstadual: "540036650111",
                        telefone: {
                            dd: '11',
                            numero: '32186666'
                        }
                    },
                    destinatario: {
                        cpfCnpj: nfInfo.notaFiscal[0]?.cnpj?.replace(/\D/g, ''),
                        razaoSocial: !nfInfo.notaFiscalDeRemessa ? nfInfo?.destinatarioNome : nfInfo?.destinatarioFornecedorNome,
                        email: nfInfo?.email || "contato@cliente.com.br",
                        inscricaoEstadual: destinatarioInfoBase?.inscricaoEstadual || undefined,
                        telefone: {
                            dd: telefoneDestinatario ? telefoneDestinatario.slice(0, 2) : '11',
                            numero: telefoneDestinatario ? telefoneDestinatario.slice(2) : '999999999'
                        },
                        endereco: {
                            logradouro: nfInfo.notaFiscal[0]?.destinatarioLogradouro || destinatarioInfoBase?.cobrancaEndereco || "Logradouro não informado",
                            numero: nfInfo.notaFiscal[0]?.destinatarioNumero || destinatarioInfoBase?.cobrancaNumero || "S/N",
                            bairro: nfInfo.notaFiscal[0]?.destinatarioBairro || destinatarioInfoBase?.cobrancaBairro || "Bairro não informado",
                            codigoCidade: nfInfo.notaFiscal[0]?.codigoCidade || "4115200",
                            descricaoCidade: nfInfo.notaFiscal[0]?.destinatarioCidade || destinatarioInfoBase?.cobrancaCidadeNome || "Cidade não informada",
                            estado: nfInfo.notaFiscal[0]?.uf || "MG",
                            cep: nfInfo.notaFiscal[0]?.destinatarioCep?.replace(/\D/g, '') || destinatarioInfoBase?.cobrancaCEP?.replace(/\D/g, '') || "00000000"
                        }
                    },
                    itens: itens,
                    pagamentos: [
                        {
                            //tipo: nfInfo.notaFiscal[0].condicaoPagamento == 'á vista' ? "aVista" : nfInfo.notaFiscal[0].condicaoPagamento == 'á prazo' ? "aPrazo" : "",
                            aVista:  nfInfo.notaFiscal[0].condicaoPagamento == 'á vista' ? true : false,
                            meio: nfInfo.notaFiscal[0]?.meioPagamento?.replaceAll('_', ' ') ? this.getMeioPagamento(nfInfo.notaFiscal[0]?.meioPagamento?.replaceAll('_', ' ')) || 1 : 1,
                            valor: sum / 100,
                        }
                    ],
                    cobranca: nfInfo.notaFiscal[0].condicaoPagamento == 'á vista' ? undefined : {
                        numero: "12345",
                        valorLiquido: fisPreDocEmiFin.length > 0 ? valorLiquido : sum / 100,
                        valorTotal: fisPreDocEmiFin.length > 0 ? totalCobranca : sum / 100,
                        parcelas: fisPreDocEmiFin.length > 0 ? fisPreDocEmiFin.map((p) => {
                            return {
                                dataVencimento: new Date(p.dtPag),
                                numero: `00${p.parcelaSequencia}`,
                                tipoPagamento: 1,
                                valor: p.vlr / 100
                            }
                        }) : undefined
                    },
                    transporte: {
                        modalidadeFrete: this.mapTipoFreteToModalidadeFrete(romaneios[0]?.tipoFrete).toString(),
                        transportador: {
                            cnpj: transportadora?.cnpj?.replace(/\D/g, ''),
                            inscricaoEstadual: transportadora?.inscricaoEstadual?.trim(),
                            nome: transportadora?.nomeFantasia || transportadora?.razaoSocial,
                            endereco: {
                                logradouro: transportadora?.entregaEndereco,
                                descricaoCidade:  transportadora?.entregaCidadeNome,
                                uf: this.getSigla(transportadora?.entregaEstadoNome)
                            }
                        },
                        volumes: [
                            {
                                quantidade: Number(nfInfo.notaFiscal[0].volumeQuantidade),
                                especie: nfInfo.notaFiscal[0].especie,
                                marca: nfInfo.notaFiscal[0].marca,
                                numeracao: nfInfo.notaFiscal[0].volumeNumeracao,
                                pesoLiquido: Number(nfInfo.notaFiscal[0]?.pesoLiquido?.replace(',', '.')),
                                pesoBruto: Number(nfInfo.notaFiscal[0]?.pesoBruto?.replace(',', '.'))
                            }
                        ]
                    },
                    //imprimirLocalRetiradaEntrega: true,
                    localRetirada: isRetiradaAndEntrega ? localRetirada : undefined,
                    localEntrega: isRetiradaAndEntrega ? {
                        cpfCnpj: nfInfo.notaFiscal[0]?.cnpj?.replace(/\D/g, ''),
                        razaoSocial: !nfInfo.notaFiscalDeRemessa ? nfInfo?.destinatarioNome : nfInfo?.destinatarioFornecedorNome,
                        email: nfInfo?.email,
                        endereco: {
                            logradouro: nfInfo.notaFiscal[0]?.destinatarioLogradouro || destinatarioInfoBase?.cobrancaEndereco || "Logradouro não informado",
                            numero: nfInfo.notaFiscal[0]?.destinatarioNumero || destinatarioInfoBase?.cobrancaNumero || "S/N",
                            bairro: nfInfo.notaFiscal[0]?.destinatarioBairro || destinatarioInfoBase?.cobrancaBairro || "Bairro não informado",
                            codigoCidade: nfInfo.notaFiscal[0]?.codigoCidade || "3552205",
                            descricaoCidade: nfInfo.notaFiscal[0]?.destinatarioCidade || destinatarioInfoBase?.cobrancaCidadeNome || "Cidade não informada",
                            estado: nfInfo.notaFiscal[0]?.uf,
                            cep: nfInfo.notaFiscal[0]?.destinatarioCep?.replace(/\D/g, '') || destinatarioInfoBase?.cobrancaCEP?.replace(/\D/g, '') || "00000000"
                        }
                    } : undefined,
                    dataSaidaEntrada: new Date() //? new Date(nfInfo.notaFiscal[0].dataSaida) : new Date(),
                }

            return nfData
        },


        getSigla(estado) {
            switch (estado) {
                case "Acre": return "AC";
                case "Alagoas": return "AL";
                case "Amapá": return "AP";
                case "Amazonas": return "AM";
                case "Bahia": return "BA";
                case "Ceará": return "CE";
                case "Distrito Federal": return "DF";
                case "Espírito Santo": return "ES";
                case "Goiás": return "GO";
                case "Maranhão": return "MA";
                case "Mato Grosso": return "MT";
                case "Mato Grosso do Sul": return "MS";
                case "Minas Gerais": return "MG";
                case "Pará": return "PA";
                case "Paraíba": return "PB";
                case "Paraná": return "PR";
                case "Pernambuco": return "PE";
                case "Piauí": return "PI";
                case "Rio de Janeiro": return "RJ";
                case "Rio Grande do Norte": return "RN";
                case "Rio Grande do Sul": return "RS";
                case "Rondônia": return "RO";
                case "Roraima": return "RR";
                case "Santa Catarina": return "SC";
                case "São Paulo": return "SP";
                case "Sergipe": return "SE";
                case "Tocantins": return "TO";
                default: return null; // caso não encontre
            }
        },

        removerAcentos(texto) {
            return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
        },
        

        mapTipoFreteToModalidadeFrete(tipoFrete) {
            if (!tipoFrete) throw new Error("tipoFrete não informado")

            // Extrai o código (primeira palavra)
            const codigo = tipoFrete.trim().substring(0, 3).toUpperCase()

            const vendedorPaga = ["CIF", "CFR", "CIP", "CPT", "DAP", "DPU", "DDP"]
            const compradorPaga = ["FOB", "EXW", "FCA", "FAS"]

            if (vendedorPaga.includes(codigo)) return 0
            if (compradorPaga.includes(codigo)) return 1

            throw new Error(`Incoterm inválido: ${codigo}`)
        },


        getMeioPagamento(meioPagamento){
            switch (meioPagamento) {
                case "Dinheiro":
                return "01"
                case "Cheque":
                return "02"
                case "Cartão de Crédito":
                return "03"
                case "Cartão de Débito":
                return "04"
                case "Cartão da Loja":
                return "05"
                case "Vale Alimentação":
                return "10"
                case "Vale Refeição":
                return "11"
                case "Vale Presente":
                return "12"
                case "Vale Combustível":
                return "13"
                case "Boleto Bancário":
                return "15"
                case "Depósito Bancário":
                return "16"
                case "Pagamento Instantâneo (PIX) - Dinâmico":
                return "17"
                case "Transferência bancária, Carteira Digital":
                return "18"
                case "Program de fidelidade, Cashback, Crédito Virtual":
                return "19"
                case "Pagamento Instantâneo (PIX) - Estático":
                return "20"
                case "Crédito em Loja":
                return "21"
                case "Pagamento Eletrônico não Informado - falha de hardware do sistema emissor":
                return "22"
                case "Sem pagamento":
                return "90"
                case "Pagamento Posterior":
                return "91"
                case "Outros":
                return "01"
                default:
                return "01"
            }
        },

        getNumberModFrete(modFrete){
            switch(modFrete){
                case 'Por conta do emitente':
                    return 0

                case 'Por conta do destinatário/remetente':
                    return 1

                case 'Por conta de terceiros':
                    return 2

                case 'Transporte Próprio por conta do Remetente':
                    return 3

                case 'Transporte Próprio por conta do Destinatário':
                    return 4

                case 'Sem frete':
                    return 5

                default:
                    return 0
            }
        },

        handleAlertCancel(nfInfo) {
            this.openAlertCancel = true
            this.itemNf = nfInfo
        },

        async confirmCancel(motivo){
            this.openAlertCancel = false

            if(this.itemNf.tipoNotaFiscal !== 'Nota_Fiscal_de_Serviço'){
                this.calcelNotaFiscal(this.itemNf, motivo)
            } else {
                this.cancelNotaFiscalServico(this.itemNf, motivo)
            }

            await this.getIssuanceInvoices()
        },

        async calcelNotaFiscal(infoNf, motivo) {
            console.log('nfInfo ', infoNf, JSON.parse(infoNf.plugNotasResponse))
            this.$notfy.warning("Cancelando Nota Fiscal...")

            const idIntegracao = infoNf.idIntegracao
            const idPlugNota = infoNf.plugNotasID

            try {
                const response = await axios.post(
                    `${this.baseUrl}/nfe/${idPlugNota}/cancelamento`,
                    {
                        "justificativa": motivo
                    },
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const objEmissao = {
                    plugNotasID: idPlugNota,
                    plugNotasMensagem: "Cancelamento em processamento",
                    plugNotaIdIntegracao: idIntegracao,
                    tipoNotaFiscal: infoNf.tipoNotaFiscal.replaceAll('_', ' '),
                    destinatario: infoNf.destinatario,
                    statusNf: "Denegada",
                    notaFiscalServico: infoNf.notaFiscal[0]._id,
                    valueNf: Number(infoNf.valueNf),
                    id: infoNf?._id,
                    plugNotasResponse: JSON.stringify(response.data),
                    chaveAcesso: response.data.documents[0]?.chave,
                    notaFiscalDeRemessa: infoNf.notaFiscalDeRemessa
                }

                Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisPreDocEmi', {
                        id: infoNf.notaFiscal[0]._id,
                        codigo: infoNf.notaFiscal[0].codigo,
                        addRetirada: infoNf.notaFiscal[0].addRetirada,
                        statusEmissao: "Rejeitado",
                        plugNotasID: infoNf.plugNotasID,
                        plugNotasMensagem: response.data[0].mensagem,
                        filial: infoNf.notaFiscal[0].filial,
                        job: infoNf.notaFiscal[0]?.job || undefined,
                        romaneio: infoNf.notaFiscal[0]?.romaneio || undefined,
                        cliente: infoNf.destinatario || undefined,
                        fornecedor: infoNf.destinatarioFornecedor || undefined,
                        cnpj: infoNf.notaFiscal[0].cnpj,
                        dataEmissao: infoNf.notaFiscal[0].dataEmissao,
                        naturezaOperacao: infoNf.notaFiscal[0].naturezaOperacao,
                        defFiscais: infoNf.notaFiscal[0].defFiscais || undefined,
                        condicaoPagamento: infoNf.notaFiscal[0].condicaoPagamento,
                        destinatarioCep: infoNf.notaFiscal[0].destinatarioCep,
                        destinatarioCidade: infoNf.notaFiscal[0].destinatarioCidade,
                        destinatarioLogradouro: infoNf.notaFiscal[0].destinatarioLogradouro,
                        destinatarioNumero: infoNf.notaFiscal[0].destinatarioNumero,
                        destinatarioBairro: infoNf.notaFiscal[0].destinatarioBairro,
                        codigoCidade: infoNf.notaFiscal[0].codigoCidade,
                        uf: infoNf.notaFiscal[0].uf,
                        email: infoNf.notaFiscal[0].email,
                        notaFiscalMae: infoNf.notaFiscal[0].notaFiscalMae || undefined,
                        itens: infoNf.notaFiscal[0].itens || [],
                        parcelas: infoNf.notaFiscal[0].parcelas || undefined,
                        dataSaida: infoNf.notaFiscal[0].dataSaida,
                        //
                        seguroValor: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.seguroValor || undefined,
                        informacoesAdicionais: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.informacoesAdicionais || undefined,
                        //freteTipo: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.freteTipo.replaceAll("_", ' ') || undefined,
                        //volumeQuantidade: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.volumeQuantidade || undefined,
                        volumeTipo: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.volumeTipo || undefined,
                        //pesoBruto: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.pesoBruto || undefined,
                        //pesoLiquido: infoNf.notaFiscal[0]?.project[0]?.tranportadora[0]?.pesoLiquido || undefined,
                        transportadora: infoNf.notaFiscal[0]?.transportadora,
                        volumeQuantidade: Number(infoNf.notaFiscal[0].volumeQuantidade),
                        especie: infoNf.notaFiscal[0].especie,
                        marca: infoNf.notaFiscal[0].marca,
                        volumeNumeracao: infoNf.notaFiscal[0].numeracao,
                        pesoBruto: infoNf.notaFiscal[0].pesoBruto,
                        pesoLiquido: infoNf.notaFiscal[0].pesoLiquido,
                        valorFrete: infoNf.notaFiscal[0].valorFrete,
                        valorSeguro: infoNf.notaFiscal[0].valorSeguro,
                        valorDesconto: infoNf.notaFiscal[0].valorDesconto,
                        valorOutros: infoNf.notaFiscal[0].valorOutros,
                        ncm: infoNf.notaFiscal[0].ncm,
                        cest: infoNf.notaFiscal[0].cest || undefined,
                        cfop: infoNf.notaFiscal[0].cfop || undefined,
                        fisOper: infoNf.notaFiscal[0].operacaoFiscal,
                        codigoBeneficioFiscal: infoNf.notaFiscal[0]?.codigoBeneficioFiscal || undefined,
                        meioPagamento: infoNf.notaFiscal[0].meioPagamento.replaceAll('_', ' ') || undefined,
                        informacaoAdd: infoNf.notaFiscal[0]?.informacaoAdd,
                    })
                ])

                console.log('NF cancelada com sucesso!', response.data);
                this.$notfy.success("Nota Fiscal Cancelada com sucesso.")
                

            } catch (error) {
                this.$notfy.error("Erro ao cancelar NF: ", error.response?.data || error.message)
                console.error('Erro ao cancelar NF:', error.response?.data || error.message);
            }
        },

        async cancelNotaFiscalServico(infoNf, motivo) {
            this.$notfy.warning("Cancelando Nota Fiscal de Serviço...")

            const idIntegracao = infoNf.plugNotaIdIntegracao
            const idPlugNota = infoNf.plugNotasID

                        /*
                                'https://api.plugnotas.com.br/nfse',
                    nfData,
                    {
                        headers: {
                            'X-API-KEY': '21c94f51-ca20-4ba0-a6d2-ffc23291680c',
                            'Content-Type': 'application/json'
                        }
                    }
            */

            try {
                const response = await axios.post(
                    `https://api.plugnotas.com.br/nfse/cancelar/${idPlugNota}`,
                    {
                        "codigo": idIntegracao,
                        "justificativa": motivo
                    },
                    {
                        headers: {
                            'X-API-KEY': this.apiKey,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const objEmissao = {
                    plugNotasID: infoNf.plugNotasID,
                    plugNotasMensagem: "Cancelamento em processamento",
                    plugNotaIdIntegracao: infoNf.plugNotaIdIntegracao,
                    tipoNotaFiscal: infoNf.tipoNotaFiscal?.replaceAll('_', ' '),
                    destinatario: infoNf.destinatario,
                    destinatarioFornecedor: infoNf.destinatarioFornecedor || undefined,
                    statusNf: "Denegada",
                    notaFiscalServico: infoNf.notaFiscalServico[0]._id,
                    valueNf: Number(infoNf.valueNf),
                    id: infoNf._id,
                    plugNotasResponse: JSON.stringify(response.data),
                    chaveAcesso: response.data.documents[0]?.chave,
                    ncm: infoNf.ncm,
                    cest: infoNf.cest,
                    cfop: infoNf.cfop,
                    fisOper: infoNf.operacaoFiscal
                }

                await Promise.all([
                    Vue.prototype.$http.put('/Entity/EmissaoNotasFiscais', objEmissao),
                    Vue.prototype.$http.put('/Entity/FisDocService', {
                        ...infoNf.notaFiscalServico[0],
                        id: infoNf.notaFiscalServico[0]._id,
                        _id: undefined,
                        status: "Cancelado",
                        emitenteTipoEnquadramento: infoNf.notaFiscalServico[0].emitenteTipoEnquadramento || '',
                        tomadorIm: infoNf.notaFiscalServico[0].tomadorIm || '',
                        fornecedor: infoNf.notaFiscalServico[0].fornecedor || '',
                        cnpj: infoNf.notaFiscalServico[0].emitenteCpfOrCnpj || '',
                        numero: infoNf.notaFiscalServico[0].numero || '',
                        pedido: infoNf.notaFiscalServico[0].pedido || '',
                        pdf: undefined,
                        reasoning: infoNf.notaFiscalServico[0].reasoning || '',
                        codigoCidade: infoNf.notaFiscalServico[0].codigoCidade || '',
                        tributacao: undefined
                    })
                ])

                console.log('NF cancelada com sucesso!', response.data);
                this.$notfy.success("Nota Fiscal de Serviço Cancelada com sucesso.")

            } catch (error) {
                this.$notfy.error("Erro ao cancelar NF: ", error.response?.data || error.message)
                console.error('Erro ao cancelar NF:', error.response?.data || error.message);
            }
        }
    },
    async created(){
        await this.getIssuanceInvoices()

        console.log("TESTE >>> ", this.baseUrl, this.apiKey)
    }
}
</script>

<style scoped>
    .container {
        width: '100%'
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }
</style>